import { z } from 'zod';
import { CognitoSubSchema, TimestampSchema } from '../common.js';
import { VoiceConsentLanguageSchema, VoiceMobileRecordingMimeSchema } from './agentVoiceProfile.js';
export const VoiceCaptureStatusSchema = z.enum([
    'pending',
    'processing',
    'ready',
    'failed',
    'revoked',
]);
export const VoiceCaptureRecordingSchema = z
    .object({
    s3Key: z.string().min(1).max(1_024),
    mime: VoiceMobileRecordingMimeSchema,
    bytes: z
        .number()
        .int()
        .positive()
        .max(25 * 1024 * 1024),
    durationMs: z.number().int().min(1_000).max(30_000),
})
    .strict();
export const AgentVoiceCaptureFieldsSchema = z
    .object({
    tenantId: z.string().uuid(),
    agentId: z.string().uuid(),
    captureId: z.string().uuid(),
    tokenHash: z.string().regex(/^[0-9a-f]{64}$/),
    status: VoiceCaptureStatusSchema,
    name: z.string().min(1).max(64),
    consentLanguage: VoiceConsentLanguageSchema,
    consentRecording: VoiceCaptureRecordingSchema.optional(),
    sampleRecording: VoiceCaptureRecordingSchema.optional(),
    failureCode: z.string().min(1).max(80).optional(),
    failureMessage: z.string().min(1).max(500).optional(),
    createdAt: TimestampSchema,
    createdBy: CognitoSubSchema,
    updatedAt: TimestampSchema,
    expiresAt: TimestampSchema,
    ttl: z.number().int().positive(),
})
    .strict();
export const AgentVoiceCaptureSchema = AgentVoiceCaptureFieldsSchema.superRefine((capture, ctx) => {
    const hasBothRecordings = capture.consentRecording !== undefined && capture.sampleRecording !== undefined;
    if ((capture.status === 'processing' || capture.status === 'ready') && !hasBothRecordings) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['status'],
            message: 'Processing and ready captures require both recordings.',
        });
    }
    const hasFailure = capture.failureCode !== undefined && capture.failureMessage !== undefined;
    if ((capture.status === 'failed') !== hasFailure) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['failureCode'],
            message: 'Only failed captures carry failure metadata.',
        });
    }
});
//# sourceMappingURL=agentVoiceCapture.js.map